<div class="close-accout-wrapper">

  <p class="hand-icon">🤚</p>
  <p class="close-accout-qn">{{'delete-data.Delete' | translate }}</p>
  <p class="keep-my-account">{{'delete-data.account' | translate }}</p>
  <ion-button class="close-accout-btn" (click)="removeData()">{{'delete-data.Yes' | translate }}</ion-button>
  <p class="keep-my-account" (click)="cancel()">{{'delete-data.No' | translate }}</p>

</div>